/*
 * Mappers from DTOs to domain models
 */

import type {
  FullUserBalance,
  FullUserBalancesResult,
  UserBalance,
  UserBalancesResult,
} from '@/lib/api/user-balances/models';
import type {
  FullUserBalanceDto,
  FullUserBalanceListResponse,
  UserBalanceDto,
  UserBalanceListResponse,
} from '@/lib/api/user-balances/types';

export function mapUserBalance(dto: UserBalanceDto): UserBalance {
  const value = typeof dto.v === 'string' ? parseFloat(dto.v) : dto.v;
  const totalVolume =
    dto.tv !== undefined ? (typeof dto.tv === 'string' ? parseFloat(dto.tv) : dto.tv) : undefined;
  const averageOpenPrice =
    dto.aop !== undefined
      ? typeof dto.aop === 'string'
        ? parseFloat(dto.aop)
        : dto.aop
      : undefined;
  const cost =
    dto.c !== undefined ? (typeof dto.c === 'string' ? parseFloat(dto.c) : dto.c) : undefined;

  return {
    id: dto.i,
    userId: dto.u,
    eventTokenId: dto.et,
    value: Number.isNaN(value) || !Number.isFinite(value) ? 0 : value,
    totalVolume:
      totalVolume !== undefined && (Number.isNaN(totalVolume) || !Number.isFinite(totalVolume))
        ? undefined
        : totalVolume,
    averageOpenPrice:
      averageOpenPrice !== undefined &&
      (Number.isNaN(averageOpenPrice) || !Number.isFinite(averageOpenPrice))
        ? undefined
        : averageOpenPrice,
    cost: cost !== undefined && (Number.isNaN(cost) || !Number.isFinite(cost)) ? undefined : cost,
  };
}

export function mapUserBalanceListResponse(response: UserBalanceListResponse): UserBalancesResult {
  return {
    balances: (response.i ?? []).map(mapUserBalance),
    page: response.p ?? 0,
    size: response.s ?? 0,
    totalPages: response.tp ?? 0,
  };
}

export function mapFullUserBalance(dto: FullUserBalanceDto): FullUserBalance {
  const value = typeof dto.v === 'string' ? parseFloat(dto.v) : dto.v;
  const totalValue =
    dto.tv !== undefined ? (typeof dto.tv === 'string' ? parseFloat(dto.tv) : dto.tv) : undefined;
  const averageOpenPrice =
    dto.aop !== undefined
      ? typeof dto.aop === 'string'
        ? parseFloat(dto.aop)
        : dto.aop
      : undefined;
  const cost =
    dto.c !== undefined ? (typeof dto.c === 'string' ? parseFloat(dto.c) : dto.c) : undefined;

  return {
    id: dto.i,
    userId: dto.u,
    eventTokenId: dto.et,
    value: Number.isNaN(value) || !Number.isFinite(value) ? 0 : value,
    totalValue:
      totalValue !== undefined && (Number.isNaN(totalValue) || !Number.isFinite(totalValue))
        ? undefined
        : totalValue,
    averageOpenPrice:
      averageOpenPrice !== undefined &&
      (Number.isNaN(averageOpenPrice) || !Number.isFinite(averageOpenPrice))
        ? undefined
        : averageOpenPrice,
    cost: cost !== undefined && (Number.isNaN(cost) || !Number.isFinite(cost)) ? undefined : cost,
    eventQuestion: dto.eq,
    eventIcon: dto.ei,
    eventSlug: dto.es,
    outcomeName: dto.on,
    tokenName: dto.tn,
    isPrimary: dto.ip,
    eventId: dto.eid,
    outcomeId: dto.oid,
  };
}

export function mapFullUserBalanceListResponse(
  response: FullUserBalanceListResponse,
): FullUserBalancesResult {
  return {
    balances: (response.i ?? []).map(mapFullUserBalance),
    page: response.p ?? 0,
    size: response.s ?? 0,
    totalPages: response.tp ?? 0,
  };
}
